import { Link } from "react-router-dom";

import { styled } from "simplydo/react/styled";

const StyledButton = styled(Link)<{ $selected: boolean | undefined }>`
  display: block;
  padding: 0.6em 1.25em;
  cursor: pointer;
  min-height: 1em;
  font-weight: 700;
  line-height: 1em;
  border-radius: 0.25rem;
  background-color: ${({ $selected, theme }) =>
    $selected ? theme.primaryColour : "#fff"};
  color: ${({ $selected, theme }) =>
    $selected && theme.shouldBeWhiteOnPrimary ? "#fff" : "#333"} !important;
  transition: background-color 0.2s;
  &:hover {
    background-color: ${({ $selected, theme }) =>
      $selected ? theme.primaryColour : "#e9ebee"};
  }
`;

type HighlightLinkProps = {
  as: React.ElementType;
  to: string;
  selected?: boolean;
  content: string;
  target?: string;
} & React.HTMLAttributes<HTMLAnchorElement>;

const HighlightLink = ({
  to,
  selected,
  content,
  ...rest
}: HighlightLinkProps) => (
  <StyledButton to={to} content={content} $selected={selected} {...rest}>
    {content}
  </StyledButton>
);

export default HighlightLink;
